import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../../../core/services/theme.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [MatCardModule, MatButtonModule, MatIconModule, RouterModule],
  template: `
    <div class="container">
      <mat-card>
        <mat-card-header>
          <mat-icon mat-card-avatar color="warn">lock</mat-icon>
          <mat-card-title>Access Denied</mat-card-title>
          <mat-card-subtitle
            >You don't have permission to access this
            resource</mat-card-subtitle
          >
        </mat-card-header>

        <mat-card-content>
          <p>
            You don't have the required permissions to access this page. If you
            believe this is an error, please contact your administrator.
          </p>
        </mat-card-content>

        <mat-card-actions>
          <button mat-button color="primary" routerLink="/dashboard">
            Go to Dashboard
          </button>
          <button mat-button (click)="logout()">Logout</button>
        </mat-card-actions>
      </mat-card>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        padding: 20px;
        background-color: var(--color-bg);
        color: var(--color-fg);
      }

      mat-card {
        max-width: 500px;
        width: 100%;
        background-color: var(--color-bg-card);
        color: var(--color-fg);
      }

      mat-card-content {
        padding: 16px;
      }
    `,
  ],
})
export class UnauthorizedComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private themeService = inject(ThemeService);

  logout(): void {
    this.authService
      .signOut()
      .then(() => {
        this.router.navigate(['/login']);
      })
      .catch((error) => {
        console.error('Error during logout:', error);
        this.router.navigate(['/login']);
      });
  }
}
